(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romh-launch-popup"]) return;
  try {
    
(() => {
  function setupLaunchPopup() {
    const dialog = document.querySelector('[data-romh-launch-popup]');
    if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
    dialog.dataset.initialized = 'true';
    const key = 'romh-launch-discount-v1';
    let previousFocus = null;
    function remember(value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {} }
    function open() { if (!dialog.isConnected || dialog.open || document.querySelector('dialog[open]')) return; previousFocus = document.activeElement; dialog.showModal(); }
    function close() { if (dialog.open) dialog.close(); remember(dialog.querySelector('[data-launch-success]') ? {submitted:true} : {dismissed:Date.now()}); if (previousFocus && previousFocus.isConnected) previousFocus.focus(); }
    dialog.querySelectorAll('[data-launch-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } });
    if (dialog.querySelector('[data-launch-success]')) { remember({submitted:true}); open(); return; }
    if (dialog.querySelector('[data-launch-error]')) { open(); return; }
    try { const value = JSON.parse(localStorage.getItem(key) || 'null'); if (value && (value.submitted || Date.now() - value.dismissed < 7 * 86400000)) return; } catch (_) {}
    if (dialog.dataset.preview !== 'true') window.setTimeout(open, Number(dialog.dataset.delay) || 12000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupLaunchPopup); else setupLaunchPopup();
  document.addEventListener('shopify:section:load', setupLaunchPopup);
})();

  } catch(e) { console.error(e); }
})();
})();
